import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../static/images/more3.png'


const _withScopeId = n => (_pushScopeId("data-v-28ee2c8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ins-banner" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "txt padding" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "bread padding" }
const _hoisted_6 = { class: "bd" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("首页")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("关于我们")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "公司介绍", -1))
const _hoisted_10 = { class: "ins-nav-box" }
const _hoisted_11 = { class: "ins-nav" }
const _hoisted_12 = { class: "news padding" }
const _hoisted_13 = { class: "news-items" }
const _hoisted_14 = { class: "img" }
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "meng" }, null, -1))
const _hoisted_17 = { class: "txt" }
const _hoisted_18 = { class: "time" }
const _hoisted_19 = {
  key: 0,
  class: "f"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "了解详情", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: _ctx.banner.banner,
        alt: "",
        class: "img"
      }, null, 8, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h5", null, _toDisplayString(_ctx.parent.name), 1),
        _createElementVNode("h3", {
          innerHTML: _ctx.parent.text
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, { to: "" }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "" }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }),
          _hoisted_9
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navList, (item) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            to: { path: '/news', query: {id: item.id} },
            key: item.id,
            class: _normalizeClass(_ctx.route.query.id == item.id ? 'link active' : 'link')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.name), 1)
            ]),
            _: 2
          }, 1032, ["to", "class"]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.List, (item, index) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            to: { path: '/news-detail/' + item.id },
            class: _normalizeClass(index == 0 ? 'item item1' : (index == 1 ? 'item item2' : 'item')),
            key: item.id
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("img", {
                  src: item.image,
                  alt: "",
                  class: "gd"
                }, null, 8, _hoisted_15)
              ]),
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("h6", null, _toDisplayString(item.title), 1),
                _createElementVNode("div", _hoisted_18, "时间：" + _toDisplayString(_ctx.common.formatTime(item.publishtime + '000')), 1)
              ]),
              (index == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_22))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["to", "class"]))
        }), 128))
      ]),
      _createVNode(_component_el_pagination, {
        currentPage: _ctx.currentPage,
        "page-size": _ctx.pageSize,
        layout: "prev, pager, next, jumper",
        total: _ctx.totalNum,
        "onUpdate:currentPage": _ctx.handleCurrentChange
      }, null, 8, ["currentPage", "page-size", "total", "onUpdate:currentPage"])
    ]),
    _createVNode(_component_Footer)
  ], 64))
}